<template>
	<div>
		<div class="welcome-login text-center">
			<!-- display the district info -->
			<img v-if="logoSrc" :src="logoSrc" />
			<h3 class="district-name">{{ districtName }}</h3>
			<hr/>
			<!-- display any messages -->
			<div v-if="getActiveMessage"
				id="formFeedback"
				:class="getMessageClass"
				v-html="getActiveMessage.content">
			</div>
			
			<h3>Account Application for <br/> <strong>{{ districtName }}</strong></h3>
			<template v-if="!skipKeyword">
				<p class="text-left">
					To continue, please enter the <strong>KEYWORD</strong> for the district you wish to sign up for.
				</p>
			</template>
			<template v-else>
				<p>You are applying for a Sapphire Community Portal account at the following district.</p>
				<div class="alert alert-info">
					<strong>{{ districtName }}</strong>
				</div>
				<p>If this is correct press the continue button to proceed to the next step.</p>
			</template>
		</div>
		<!-- TODO: form will post to portal home page -->

		<form method="post" ref="form" @submit.prevent="validateBeforeSubmit" :action="'index.cfm/user-policy'">
			<input type="hidden" name="_csrftoken" :value="csrfToken" />
			<div class="form-group"  :class="{'has-warning': errors.has('keyword') }" v-if="!skipKeyword">
				<label for="keyword">
					Keyword
				</label>
				<input 
					type="text" 
					class="form-control" 
					name="keyword" 
					v-model="keyword" 
					v-validate="'required'">
				
				<div v-show="errors.has( 'keyword' )">
					<small class="invalid-feedback">{{ errors.first( 'keyword' ) }}</small>
				</div>
			</div>

			<div class="">
				<button 
					type="submit"
					class="btn btn-block btn-primary"
					:disabled="isFormInvalid">
					Continue
				</button>
			</div>
		</form>
		<div class="go-back">
			<a :href="entrypoint"><i class="fas fa-chevron-left"></i> Go Back</a>
		</div>
	</div>
</template>

<script>
	export default{
		props:{
			districtName : "",
			logoSrc : "",
			csrfToken : "",
			message : {
				type: Object,
			},
			skipKeyword : {
				type: Boolean,
				required: true,
				default: false
			},
			entrypoint : {
				type: String,
				required: true
			}
		},
		data(){
			return{
				keyword: ""
			}
		},
		computed: {
			isFormInvalid() {
				return Object.keys( this.fields ).some( key => this.fields[ key ].invalid );
			},
			isFormTouched() {
				return Object.keys( this.fields ).some( key => this.fields[ key ].touched );
			},
			getMessageClass() {
				return "alert alert-" + this.getActiveMessage.category;
			},
			getActiveMessage() {
				if( this.isFormInvalid && this.isFormTouched ){
					return {
						category : "warning",
						content : "Some required fields are missing!"
					}
				} else{
					return this.message;
				}
			}

		},
		methods: {
			validateBeforeSubmit() {
				this.$validator.validateAll().then((result) => {
					if (result) {
						this.$refs.form.submit();
						return;
					}
				});
			}
		}  
	}
</script>